import { FC } from 'react';
import { msgBoxId } from '../../../../utils/const';
import { IMessageItem, MessageBox } from './MessageBox';

export interface IMessageProps {
  messages: IMessageItem[];
  loading: boolean;
  responding: boolean;
}

export const Message: FC<IMessageProps> = (props) => {
  const { messages, loading, responding } = props;
  return (
    <div className="w-ful flex flex-col gap-8 px-5 pb-8">
      {messages.map((message, index) => {
        if (message.type === 'User') {
          return (
            <div
              key={message.id}
              className="self-end bg-[#F2F4F8] px-6 py-3 text-[#04252B] text-base rounded-3xl max-w-[38rem]"
            >
              {message.content}
            </div>
          );
        } else {
          return (
            <MessageBox
              key={message.id}
              message={message}
              loading={loading && index === messages.length - 1}
              responding={responding && index === messages.length - 1}
            />
          );
        }
      })}
      <div className="w-fll h-1" id={msgBoxId} />
    </div>
  );
};
